module.exports = __webpack_public_path__ + "static/media/logo-oiweek-black.f1753553.png";